import yup from '@/plugins/yup'
import { i18n } from '@/plugins/i18n'

const { t } = i18n.global

const RegisterSearchBarSchema = yup.object().shape({
  sensor: yup.object().required('Sensor é obrigatório'),
  period: yup.array().of(yup.date()).length(2, 'Selecione um período válido').required('O período é obrigatório'),
})

export default RegisterSearchBarSchema
